<div class="charts-wrapper">
  <div class="labels-wrapper ">
    <span class="type-label">{{lineChartAngle}}°</span>
  </div>

  <canvas id="{{boxplotId}}"></canvas>
</div>
